import { render, staticRenderFns } from "./VodNew.vue?vue&type=template&id=2dbf59f4&scoped=true&"
import script from "./VodNew.vue?vue&type=script&lang=js&"
export * from "./VodNew.vue?vue&type=script&lang=js&"
import style0 from "./VodNew.vue?vue&type=style&index=0&id=2dbf59f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf59f4",
  null
  
)

export default component.exports